// extracted by mini-css-extract-plugin
export var col = "styles-module--col--XnByN";
export var cols = "styles-module--cols--cwfJS";
export var pattern = "styles-module--pattern--DJuai";
export var textLarge = "styles-module--textLarge--AvHL7";
export var textMedium = "styles-module--textMedium--MYEo7";
export var textNormal = "styles-module--textNormal--bK0q9";
export var textSmall = "styles-module--textSmall--e5Lve";
export var textTiny = "styles-module--textTiny--tkjVS";
export var textXsmall = "styles-module--textXsmall--ys7ef";